var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlLuggageRackOutlined = function SvgHtlLuggageRackOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 12.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm-7 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0ZM4.5 10a1.47 1.47 0 0 1-1.152-.455A1.49 1.49 0 0 1 3 8.48V3.707l-.854-.853a.5.5 0 0 1 .708-.707L4 3.293v5.258a.51.51 0 0 0 .1.329c.115.09.26.133.405.12h.5V5a1 1 0 0 1 1-1h1V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h1a1 1 0 0 1 1 1v4h1.5a.5.5 0 1 1 0 1H4.5ZM6 9h5V5H6v4Zm3-5V3H8v1h1Z"
  })));
};
export default SvgHtlLuggageRackOutlined;